import React, { PureComponent } from 'react';

import { Button, ButtonIcon } from 'components/button';
import { InputFile } from 'components/input';
import { ModalWithoutPortal } from 'components/modal/ModalWithoutPortal';
import { I18n } from 'components/translate';
import { DatahubEventsService } from 'modules/app/services';
import { ViewUploadSubtitles } from 'modules/app/services/datahubEvents/media';
import SubtitleActions from 'modules/subtitle/SubtitleActions';
import PropTypes from 'prop-types';

import SubtitleSupportedLangs from '../SubtitleSupportedLangs';

export default class SubtitleUploadModal extends PureComponent {
  constructor(props) {
    super(props);

    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  state = {
    selectedLang: null,
    selectedFile: null
  };

  static propTypes = {
    mediaId: PropTypes.string
  };

  componentDidMount() {
    DatahubEventsService.sendEvent({
      schema: new ViewUploadSubtitles({
        arrivedFrom: window.location.href
      })
    });
  }

  get isUploadEnabled() {
    const { selectedLang, selectedFile } = this.state;

    return Boolean(selectedLang) && Boolean(selectedFile);
  }

  onSelectFile = (selectedFile) => {
    this.setState({ selectedFile });
  };

  onUpload = () => {
    const { mediaId } = this.props;
    const { selectedFile, selectedLang } = this.state;

    SubtitleActions.uploadSubtitle(mediaId, selectedLang, selectedFile);
    this.handleCloseModal();
  };

  handleCloseModal() {
    const { closeModal } = this._modal.getContext().actions;

    closeModal();
  }

  setSelectedLang = (value) => this.setState({ selectedLang: value });

  render() {
    const { mediaId } = this.props;

    return (
      <ModalWithoutPortal
        ref={(node) => (this._modal = node)}
        className="subtitle__modal subtitle__modal__upload"
        {...this.props}
      >
        <ModalWithoutPortal.Header>
          <h5 className="modal-header-warning">
            <I18n label="player_subtitles.label" />
          </h5>
          <h2 className="mt__sm">
            <I18n label="player_subtitles.upload.label" />
          </h2>

          <ButtonIcon
            className="close"
            transparent
            type="secondary"
            icon="close"
            onClick={this.handleCloseModal}
          />
        </ModalWithoutPortal.Header>

        <ModalWithoutPortal.Body>
          <label>
            <I18n label="general.choose_language" />
          </label>
          <SubtitleSupportedLangs
            mediaId={mediaId}
            placeholder="player_subtitles.upload.placeholder_language"
            onSelectLang={this.setSelectedLang}
          />

          <label className="mt__md">
            <I18n label="player_subtitles.upload.choose_file" />
          </label>
          <InputFile
            className="subtitle__upload__input"
            onChange={this.onSelectFile}
          />
        </ModalWithoutPortal.Body>

        <ModalWithoutPortal.Footer>
          <Button
            size="large"
            onClick={this.onUpload}
            disabled={!this.isUploadEnabled}
          >
            <I18n label="general.send" />
          </Button>
          <Button size="large" outline onClick={this.handleCloseModal}>
            <I18n label="general.cancel" />
          </Button>
        </ModalWithoutPortal.Footer>
      </ModalWithoutPortal>
    );
  }
}
